// extracted by mini-css-extract-plugin
module.exports = {"body":"app_body__5lgNh"};